var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"component-paginate-tablehead",class:{
		'sort': !!_vm.sortBy,
		'sorted': !!_vm.sortBy && _vm.sortBy === _vm.order,
		'sort-desc': _vm.direction === _vm.AscDesc.DESC,
	},on:{"click":function($event){return _vm.onOrderBy()}}},[_c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:(!!_vm.sortBy),expression:"!!sortBy"}],staticClass:"paginate-tablehead-container"},[(!!_vm.sortBy)?_c('v-icon',{staticClass:"arrow-sort"},[_vm._v("mdi-arrow-up")]):_vm._e(),_c('div',{staticClass:"paginate-tablehead-data"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }